module.exports = __webpack_public_path__ + "img/山楂.a6e6b1f2.jpg";